'use client'

import { useEffect, useState, type ReactNode } from 'react'

/**
 * Redirects unauthenticated users to pathway mobile-auth,
 * then returns them to the exact mafia URL they tried to open.
 */
export function MafiaAuthGate({ children }: { children: ReactNode }) {
  const [allowed, setAllowed] = useState(false)

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'
    const returnPath =
      window.location.pathname + window.location.search

    if (!isLoggedIn) {
      localStorage.setItem(
        'redirectAfterLogin',
        JSON.stringify({ path: returnPath })
      )
      window.location.href = '/pathway?window=mobile-auth'
      return
    }

    setAllowed(true)
  }, [])

  if (!allowed) {
    return (
      <div className="flex min-h-screen items-center justify-center text-[var(--mafia-muted)]">
        در حال انتقال به صفحه ورود…
      </div>
    )
  }

  return <>{children}</>
}
